export const WORKENDTYPE_DEFAULT = 0;
export const WORKENDTYPE_UP = 1;
export const WORKENDTYPE_RECE = 2;